// Enhanced URL Replacer - Replaces ~CODE~ in URLs with the customer's course code
(function() {
  // Function to replace ~CODE~ in all links and data-links
  function replaceCodeInUrls() {
    // Get the course code from the global variable
    var courseCode = window.js_course_code;
    
    // Debugging output
    //console.log('URL Replacer running. Course code:', courseCode);
    //console.log('js_course_code type:', typeof window.js_course_code);
    
    // If no course code is found, exit
    if (!courseCode || courseCode === "" || courseCode === "null") {
      //console.log('URL Replacer: No valid course code found, skipping replacement');
      return;
    }
    
    // Log original links for debugging
    //console.log('Checking for links with ~CODE~');
    document.querySelectorAll('a').forEach(function(link) {
      var href = link.href || link.getAttribute('href');
      if (href && href.includes('~CODE~')) {
        //console.log('Found link with ~CODE~:', href);
      }
    });
    
    // Direct href property replacement (for fully resolved URLs)
    document.querySelectorAll('a').forEach(function(link) {
      if (link.href && link.href.includes('~CODE~')) {
        var originalHref = link.href;
        link.href = originalHref.replace(/~CODE~/g, courseCode);
        //console.log('Replaced in href property:', originalHref, '->', link.href);
      }
    });
    
    // Attribute-based replacement (for relative URLs and special cases)
    document.querySelectorAll('a[href*="~CODE~"]').forEach(function(link) {
      var originalHref = link.getAttribute('href');
      var newHref = originalHref.replace(/~CODE~/g, courseCode);
      link.setAttribute('href', newHref);
      //console.log('Replaced in href attribute:', originalHref, '->', newHref);
    });
    
    // Replace in summary data-link attributes
    document.querySelectorAll('summary').forEach(function(summary) {
      var dataLink = summary.getAttribute('data-link');
      if (dataLink && dataLink.includes('~CODE~')) {
        var newLink = dataLink.replace(/~CODE~/g, courseCode);
        summary.setAttribute('data-link', newLink);
        //console.log('Replaced in data-link:', dataLink, '->', newLink);
      }
    });
    
    //console.log('URL Replacer: Initial replacement complete');
  }
  
  // Function to monitor for dynamic menu changes
  function setupMenuObserver() {
    // Use a MutationObserver to watch for menu opening
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        // If nodes were added, check if they contain links with ~CODE~
        if (mutation.addedNodes.length) {
          var needsReplacement = false;
          
          mutation.addedNodes.forEach(function(node) {
            if (node.querySelectorAll) {
              var links = node.querySelectorAll('a[href*="~CODE~"]');
              if (links.length > 0) {
                needsReplacement = true;
              }
            }
          });
          
          if (needsReplacement) {
            //console.log('Detected dynamic menu items with ~CODE~, running replacement again');
            replaceCodeInUrls();
          }
        }
      });
    });
    
    // Watch for changes in the navigation area
    var navElements = document.querySelectorAll('.site-nav, .site-navigation, nav, header');
    navElements.forEach(function(element) {
      observer.observe(element, { childList: true, subtree: true });
    });
  }
  
  // Run replacements on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      replaceCodeInUrls();
      setupMenuObserver();
      
      // Run again after a short delay to catch any delayed renderings
      setTimeout(replaceCodeInUrls, 500);
    });
  } else {
    // DOM already loaded
    replaceCodeInUrls();
    setupMenuObserver();
    
    // Run again after a short delay
    setTimeout(replaceCodeInUrls, 500);
  }
  
  // Also run when the window has fully loaded (including images)
  window.addEventListener('load', replaceCodeInUrls);
  
  // For Shopify's ajax navigation
  document.addEventListener('shopify:section:load', replaceCodeInUrls);
})();